<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:09:25
 * @Description: 维保建筑新增/修改
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="建筑名称"
            prop="jzwmc"
          >
            <el-input
              v-model.trim="fd.jzwmc"
              class="c-form__input"
              placeholder="请输入建筑名称"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="建筑地址"
            prop="jzdz"
          >
            <el-input
              v-model.trim="fd.jzdz"
              class="c-form__input"
              placeholder="请输入建筑地址"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="建筑类别"
            prop="jzlbDm"
          >
            <el-select
              v-model="fd.jzlbDm"
              class="c-form__select"
              placeholder="请选择建筑类别"
              clearable
            >
              <el-option
                v-for="item in jzlbType"
                :key="item.id"
                :label="item.text"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="自动消防设备"
            prop="zdxfss"
          >
            <el-radio-group
              v-model="fd.zdxfss"
              class="c-form__radio-group"
            >
              <el-radio label="Y">
                有
              </el-radio>
              <el-radio label="N">
                无
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="占地面积（m²）"
            prop="zdmj"
          >
            <el-input
              v-model="fd.zdmj"
              class="c-form__input"
              placeholder="请输入占地面积"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="建筑面积（m²）"
            prop="jzmj"
          >
            <el-input
              v-model="fd.jzmj"
              class="c-form__input"
              placeholder="请输入建筑面积"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="楼层（数）"
            prop="lcs"
          >
            <el-input
              v-model="fd.lcs"
              class="c-form__input"
              placeholder="请输入楼层（数）"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="建筑高度（m）"
            prop="jzgd"
          >
            <el-input
              v-model="fd.jzgd"
              class="c-form__input"
              placeholder="请输入建筑高度"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="地上层层数"
            prop="dscs"
          >
            <el-input
              v-model="fd.dscs"
              class="c-form__input"
              placeholder="请输入地上层层数"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="地下层层数"
            prop="dxcs"
          >
            <el-input
              v-model="fd.dxcs"
              class="c-form__input"
              placeholder="请输入地下层层数"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="安全出口数（个）"
            prop="aqcks"
          >
            <el-input
              v-model="fd.aqcks"
              class="c-form__input"
              placeholder="请输入安全出口数"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="疏散楼梯数（个）"
            prop="sslts"
          >
            <el-input
              v-model="fd.sslts"
              class="c-form__input"
              placeholder="请输入疏散楼梯数"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="消防电梯数（个）"
            prop="xfdts"
          >
            <el-input
              v-model="fd.xfdts"
              class="c-form__input"
              placeholder="请输入消防电梯数（个）"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="避难层位置"
            prop="bncwz"
          >
            <el-input
              v-model.trim="fd.bncwz"
              class="c-form__input"
              placeholder="请输入避难层位置"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wbjzService } from './wbjz.service';

export default {
  name: 'WbjzUpdateDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    // 最大值校验
    const maxNumberValid = (rule, value, callback) => {
      const max = 2147483647;
      if (Number(value) <= max) {
        callback();
      }
      callback(new Error(`最大值不能超过${max}`));
    };
    return {
      loading: false, // 页面loading建筑类别
      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        xmId: null, // 项目id
        jzwId: null,
        jzwmc: null, // 建筑名称
        jzdz: null, // 建筑地址
        jzlbDm: null, // 建筑类别
        zdmj: null, // 占地面积
        zdxfss: null, // 自动消防设备
        jzmj: null, // 建筑面积
        lcs: null, // 楼层数
        jzgd: null, // 建筑高度
        dscs: null, // 地上层层数
        dxcs: null, // 地下层数
        aqcks: null, // 安全出口数
        sslts: null, // 疏散楼梯数
        xfdts: null, // 消防电梯数
        bncwz: null // 避难层位置
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        jzwmc: [
          this.$validUtils.required('建筑名称'),
          this.$HMValidator.maxLength('建筑名称', 300)
        ], // 建筑名称
        jzdz: [
          this.$validUtils.required('建筑地址'),
          this.$HMValidator.maxLength('建筑地址', 1000)
        ], // 建筑地址
        jzlbDm: [
          this.$validUtils.required('建筑类别')
        ], // 建筑类别
        zdmj: [
          this.$validUtils.required('占地面积'),
          this.$validUtils.positiveNumber('占地面积'),
          this.$HMValidator.money('占地面积', 10, 2)
        ], // 占地面积
        zdxfss: [
          this.$validUtils.required('自动消防设备')
        ], // 自动消防设备
        jzmj: [
          this.$validUtils.required('建筑面积'),
          this.$validUtils.positiveNumber('建筑面积'),
          this.$HMValidator.money('建筑面积', 10, 2)
        ], // 建筑面积
        lcs: [
          this.$validUtils.required('楼层数'),
          this.$HMValidator.number('楼层数')
        ], // 楼层数
        jzgd: [
          this.$validUtils.required('建筑高度'),
          this.$validUtils.positiveNumber('建筑高度'),
          this.$HMValidator.money('建筑高度', 10, 2)
        ], // 建筑高度
        dscs: [
          this.$validUtils.required('地上层层数'),
          this.$HMValidator.number('地上层层数'),
          { validator: maxNumberValid, trigger: 'change' }
        ], // 地上层数
        dxcs: [
          this.$validUtils.required('地下层数'),
          this.$HMValidator.number('地下层数'),
          { validator: maxNumberValid, trigger: 'change' }
        ], // 地下层数
        aqcks: [
          this.$HMValidator.number('安全出口数'),
          { validator: maxNumberValid, trigger: 'change' }
        ],
        sslts: [
          this.$HMValidator.number('疏散楼梯数'),
          { validator: maxNumberValid, trigger: 'change' }
        ],
        xfdts: [
          this.$HMValidator.number('消防电梯数'),
          { validator: maxNumberValid, trigger: 'change' }
        ],
        bncwz: [
          this.$HMValidator.maxLength('避难层位置', 60)
        ]
      },
      /* 表单校验规则 End */

      dlType: 'add' // 模态框类型，'add': 新增，'edit': 修改

    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'edit' ? '修改' : '新增'}`;
    },
    /* 建筑类别 */
    jzlbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JZLB_WB) {
        return enums.IFF_JZLB_WB;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 初始化维保建筑信息
     * @return {*}
     */
    init () {
      this.loading = true;
      wbjzService.getInfo(this.dlParams.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('获取职位信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.dlType === 'add') {
            this.addSave();
          } else {
            this.updateSave();
          }
        }
      });
    },
    /**
     * @description: 新增保存服务
     * @return {*}
     */
    addSave () {
      wbjzService.save(this.fd)
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('新增建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    updateSave () {
      wbjzService.update(this.fd)
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('修改建筑错误！', err);
          this.loading = false;
        });
    },

    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.fd.xmId = this.$route.params.xmId;
    console.log(this.$route.params.xmId);
    if (this.dlParams.id) {
      this.fd.jzwId = this.dlParams.id;
      this.dlType = 'edit';
      this.init();
    }
  }
};
</script>
